/**
 * Classe que gerencia as ações para os itens de lookup list
 *
 * @author: Adalto Junior
 * DATE: 18/03/2013
 *
 */


Monet.Form = Monet.Form || {};

Monet.Form.LookupList = function (scope, lookupEntity, callbacks) {


    if (typeof(scope) !== "undefined") {
        this.scope = scope;
    } else {
        this.scope = null;
    }

    if (typeof(lookupEntity) !== "undefined") {
        this.lookupEntity = lookupEntity;
    } else {
        this.lookupEntity = null;
    }

    if (typeof(callbacks) !== "undefined") {
        this.callbacks = callbacks;
    } else {
        this.callbacks = null;
    }

    this.templateLookupListItem = function(data){

        return new Monet.UI.LayoutGenerator({
            items: [{
                attributes: {
                    "id": data.lookupEntity + "_" + data.id,
                    "class": "zebrado item_lookuplist_" + data.lookupEntity + "_" + data.id
                },
                items: [
                    {
                        attributes: {
                            "class": "title_item_added"
                        },
                        html: data.title
                    },
                    {
                        attributes: {
                            "class": "del_item_added"
                        },
                        items: [{
                            attributes: {
                                "class": "table-action-destroylink"
                            },
                            html: "&nbsp;"
                        }]
                    },
                    {
                        attributes: {
                            "style": "clear:both;"
                        }
                    },
                    {
                        attributes: {
                            type: "hidden",
                            name: data.lookupEntity + "[" + data.index + "].id",
                            "id": data.lookupEntity + "[" + data.index + "].id",
                            "class": "modelAttribute",
                            value:  data.id
                        },
                        tag: "input"
                    }
                ]
            }]
        }).render();

    };

    var defaultTemplate = function (options) {

        var content = options.content,
            id = content.id,
            index = content.index,
            title = content.title,
            lookupEntity = options.lookupEntity;

        return this.templateLookupListItem({
            id: id,
            index: index,
            title: title,
            lookupEntity: lookupEntity
        });
    };

    this.addItemLookupList = function (options) {
        var error = {};
        if (this.entity !== null) {
            try {

                var templateHTML = "";
                var optionsLookup = options || {};
                optionsLookup.scope = this.scope;
                optionsLookup.lookupEntity = this.lookupEntity;

                var lookupListContainner = document.querySelector("#" + this.scope + " #" + this.lookupEntity + "_list.container_lookuplist_added");
                var id = optionsLookup.content.id;

                if (this.callbacks !== null) {

                    if (typeof(this.callbacks.customTemplateItemLookupList) !== "undefined") {

                        templateHTML = this.callbacks.customTemplateItemLookupList(optionsLookup);

                    } else {

                        templateHTML = defaultTemplate(optionsLookup);

                    }

                } else {

                    templateHTML = defaultTemplate(optionsLookup);

                }

                $(lookupListContainner).append(templateHTML);

                if (typeof(id) !== "undefined") {

                    this.addEventListennerToRemoveItem(id);

                } else {

                    error = new Monet.Exception.ReturnError(this, "No id to item on lookup list.");
                    error.console();

                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(this, "No add item to lookup list.", e);
                error.console();

            }

        } else {

            error = new Monet.Exception.ReturnError(this, "No scope defined.");
            error.console();

        }
    };

    this.addEventListennerToRemoveItem = function (id) {

        var error;

        if (id !== null && typeof(id) !== "undefined") {

            try {
                var that = this;

                var selector = "#" + this.scope + " #" + this.lookupEntity + "_list #" + this.lookupEntity + "_" + id + " .del_item_added";

                var divRemoveItem = document.querySelector(selector);

                divRemoveItem.onclick = function () {

                    that.removeItemLookupList(id);

                };

            } catch (e) {

                error = new Monet.Exception.ReturnError(this, "No add event to item.");
                error.console();

            }

        } else {

            error = new Monet.Exception.ReturnError(this, "No id defined.");
            error.console();

        }

    };

    this.removeItemLookupList = function (id) {

        var error;

        if (this.scope !== null) {

            const removeItemAction = () => {

                let canRemoveItemList = true;

                if (this.callbacks !== null && typeof(this.callbacks.beforeRemoveItem) !== "undefined") {
                    canRemoveItemList = this.callbacks.beforeRemoveItem(id);
                }

                try {

                    if (canRemoveItemList) {

                        const el = document.querySelector("#" + this.scope + " #" + this.lookupEntity + "_list .item_lookuplist_" + this.lookupEntity + "_" + id);
                        el.parentNode.removeChild(el);

                    }

                } catch (e) {
                    error = new Monet.Exception.ReturnError(this, "No element to remove.", e);
                    error.console();
                }

                if (this.callbacks !== null && typeof(this.callbacks.afterRemoveItem) !== "undefined") {
                    this.callbacks.afterRemoveItem();
                }

            };

            new Greenmile.Components.AlertModal("lookuplist.message.alertExclude",
                null,
                removeItemAction.bind(this) 
            )
            .show();

        } else {

            error = new Monet.Exception.ReturnError(this, "No scope defined.");
            error.console();

        }
    };

};
